import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import LoginScreen from './Components/LoginScreen';
import DashboardScreen from './Components/Dashboardscreen';
import RegistrationStep1 from './Components/registration/RegistrationStep1';
import RegistrationStep2 from './Components/registration/RegistrationStep2';
import RegistrationStep3 from './Components/registration/RegistrationStep3';
import RegistrationStep4 from './Components/registration/RegistrationStep4';
import RegistrationView from './Components/registration/RegistrationView';
import AdmissionScreen from './Components/AdmissionScreen';
import SuccessModal from './Components/common/SuccessModel';
import StudentAnalytics from './Components/StudentAnalytics';
import PayCardDetails from './Components/PayCardDetails';
import StudentFeeDetails from './Components/StudentFeeDetails';
import FinanceScreen from './Components/Financescreen';
import RoomAllocationScreen from './Components/Roomallocationscreen ';
import InventoryScreen from './Components/Inventoryscreen';
import UserManagementScreen from './Components/UserManagementScreen';
import GuestRegistration from './Components/GuestRegistration';
import CanteenScreen from './Components/CanteenScreen';
import NotificationsScreen from './Components/NotificationsScreen';
import PayCardOperations from './Components/PayCardOperations';
import AttendanceScreen from './Components/AttendanceScreen';
import ReportsScreen from './Components/ReportsScreen';
import StudentTenure from './Components/StudentTenure';


/* ─── Main staff app ─── */
const MainApp = () => {
  const [currentScreen,    setCurrentScreen]    = useState(() => localStorage.getItem('currentScreen') || 'login');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const viewRegistrationIdRef = useRef(null);
  const viewStudentIdRef      = useRef(null);
  const [navKey, setNavKey]   = useState(0);
  const feeStudentIdRef       = useRef(null);
  const payCardStudentIdRef   = useRef(null);

  // ✅ useState instead of useRef — triggers re-render so ReportsScreen gets new prop
  const [reportType, setReportType] = useState('registration');

  useEffect(() => { localStorage.setItem('currentScreen', currentScreen); }, [currentScreen]);

  const navigateTo = useCallback((screen, params = {}) => {
    if (params.registrationId)   viewRegistrationIdRef.current = params.registrationId;
    if (params.studentId)        viewStudentIdRef.current       = params.studentId;
    if (params.feeStudentId)     feeStudentIdRef.current        = params.feeStudentId;
    if (params.payCardStudentId) payCardStudentIdRef.current    = params.payCardStudentId;

    // ✅ Update reportType when navigating to reports submenu
    if (params.reportType)       setReportType(params.reportType);

    if (screen === 'registration1' && !params.isBack) {
      localStorage.removeItem('registrationStep1Data');
      localStorage.removeItem('registrationStep2Data');
      localStorage.removeItem('registrationStep3Data');
      localStorage.removeItem('registrationPhotoPreview');
      window.selectedPhotoFile = null;
      window.selectedDocFiles  = null;
      sessionStorage.removeItem('regPhotoData');
    }

    setCurrentScreen(screen);
    setNavKey(k => k + 1);
    window.scrollTo(0, 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleLogout = () => {
    localStorage.removeItem('currentScreen');
    setCurrentScreen('login');
  };

  return (
    <div className="app">
      {currentScreen === 'login'             && <LoginScreen onLogin={() => {
        const role = (() => { try { return JSON.parse(localStorage.getItem('user')||'{}')?.role?.toUpperCase(); } catch { return ''; } })();
        localStorage.removeItem('currentScreen');
        setTimeout(() => {
          if (role === 'CANTEEN_INCHARGE') navigateTo('canteen');
          else if (role === 'LAUNDRY_INCHARGE') navigateTo('laundry');
          else if (role === 'STORE_INCHARGE') navigateTo('inventory');
          else if (role === 'PURCHASE_OFFICER' || role === 'HOUSEKEEPING') navigateTo('inventory');
          else navigateTo('dashboard');
        }, 150);
      }} onNavigate={navigateTo} />}
      {currentScreen === 'dashboard'         && <DashboardScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration1'     && <RegistrationStep1 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration2'     && <RegistrationStep2 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration3'     && <RegistrationStep3 onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'registration4'     && <RegistrationStep4 onNavigate={navigateTo} onSubmit={() => setShowSuccessModal(true)} onLogout={handleLogout} />}
      {currentScreen === 'registrationView'  && <RegistrationView onNavigate={navigateTo} onLogout={handleLogout} registrationId={viewRegistrationIdRef.current} />}
      {currentScreen === 'admission'         && <AdmissionScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'studentAnalytics'  && <StudentAnalytics key={`analytics-${navKey}`} onNavigate={navigateTo} onLogout={handleLogout} studentId={viewStudentIdRef.current} />}
       {currentScreen === 'studentTenure'     && <StudentTenure key={`tenure-${navKey}`} onNavigate={navigateTo} onLogout={handleLogout} studentId={viewStudentIdRef.current} />}
      {currentScreen === 'rooms'             && <RoomAllocationScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'inventory'         && <InventoryScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'canteen'           && <CanteenScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'notifications'     && <NotificationsScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'finance'           && <FinanceScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'studentFeeDetails' && <StudentFeeDetails onNavigate={navigateTo} onLogout={handleLogout} studentId={feeStudentIdRef.current} />}
      {currentScreen === 'payCardDetails'    && <PayCardDetails onNavigate={navigateTo} onLogout={handleLogout} studentId={payCardStudentIdRef.current} />}
      {currentScreen === 'users'             && <UserManagementScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'payCardOperations' && <PayCardOperations onNavigate={navigateTo} onLogout={handleLogout} />}
      {currentScreen === 'attendance'        && <AttendanceScreen onNavigate={navigateTo} onLogout={handleLogout} />}
      {/* ✅ reportType passed as state — updates when user clicks different submenu */}
      {currentScreen === 'reports'           && <ReportsScreen onNavigate={navigateTo} onLogout={handleLogout} reportType={reportType} />}
      {showSuccessModal && <SuccessModal onClose={() => {
        setShowSuccessModal(false);
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        const role = (user?.role || '').toUpperCase();
        navigateTo(role === 'STUDENT' ? 'rooms' : 'dashboard');
      }} />}
    </div>
  );
};

/* ─── Root App ─── */
function App() {
  return (
    <Routes>
      <Route path="/register" element={<GuestRegistration />} />
      <Route path="/*" element={<MainApp />} />
    </Routes>
  );
}

export default App;